import Swiper, { Autoplay, Navigation } from 'swiper';

if (document.querySelector('.about-slider')) {
    const swiper = new Swiper('.about-slider .swiper', {
        modules: [Autoplay, Navigation],
        loop: true,
        speed: 700,
        spaceBetween: 80,
        slidesPerView: 1,
        breakpoints: {
            550: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
        },
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // Dodaj obsługę kliknięcia na elementy slidera
    swiper.on('click', function () {
        if (swiper.clickedSlide) {
            // Pobierz identyfikator slidu
            var popupId = swiper.clickedSlide.dataset.popupId;

            // Otwórz odpowiadający popup
            openPopup(popupId);
        }
    });

    // Funkcja otwierająca popup na podstawie identyfikatora slidu
    function openPopup(popupId) {
        var popup = document.querySelector('.about-popup[data-popup-id="' + popupId + '"]');
        popup.classList.add('active'); // Dodaj klasę "active" do popupu, aby go pokazać
    }

    // Dodaj obsługę kliknięcia na przycisk zamykający popup
    var closeButtons = document.querySelectorAll('.about-btn');
    closeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            closePopup(button.closest('.about-popup'));
        });
    });

    // Funkcja zamykająca popup
    function closePopup(popup) {
        popup.classList.remove('active'); // Usuń klasę "active" z popupu, aby go schować
    }
}
